import Vue from "vue";
import Loading from "./Loading.vue";

const Load = Vue.extend(Loading);

const Instance = new Load();
let vm = Instance.$mount();
document.body.appendChild(vm.$el);

export default {
  install: (Vue) => {
    Vue.prototype.$loading = Instance;
  },
};
